import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { OpenLead } from '../types/OpenLead';
import { DxDataGridComponent } from 'devextreme-angular';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';
@Component({
  selector: 'open-leads-by-plant',
  templateUrl: './open-leads-by-plant.component.html'
})
export class OpenLeadsByPlantComponent implements OnInit {
  @ViewChild('openLeadsGrid', { static: true }) openLeadsGrid: DxDataGridComponent;
  @ViewChild("header1", { read: ElementRef }) header1: ElementRef;
  _openLead: OpenLead[];
  _miles: number;
  @Input()
  set openLeads(value: OpenLead[]) {
    this._openLead = value;
  }

  get openLeads(): OpenLead[] {
    return this._openLead;
  }

  @Input()
  set miles(value: number) {
    this._miles = value;
    this.header = `Open Leads within ${this._miles} miles`
  }

  get miles(): number {
    return this._miles;
  }
  chooserMode: string = 'select';
  header: string;

  constructor() {

  }

  exportExcel(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('OpenLeadsByPlant');
    exportDataGrid({
      component: this.openLeadsGrid.instance,
      worksheet: worksheet,
      customizeCell: ({ gridCell, excelCell }) => {
        if ((gridCell.column.dataField === 'createdOn' || gridCell.column.dataField === 'leadSince') && excelCell._row.number > 1) {
            excelCell.numFmt = 'mm/dd/yyyy';
            excelCell.value = this.dateStringToDate(excelCell.value);
          }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'OpenLeadsByPlant.xlsx');
        });
    });
    e.cancel = true;
  }

  dateStringToDate(dateString) {
    try {
      var year = dateString.substring(0, 4);
      var month = dateString.substring(4, 6);
      var day = dateString.substring(6, 8);
      var date = new Date(year, month - 1, day, 0, 0, 0, 0);
      const offset = date.getTimezoneOffset()
      date = new Date(date.getTime() - (offset * 60 * 1000));
      return date;
    } catch (error) {
      return null;
    }
  }

  ngOnInit(): void {

  }

}